import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
import store from '@/store/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.prototype.$apiFun = apiFun;

Vue.config.productionTip = false

// 初始化：从localStorage恢复token到sessionStorage（保证请求拦截器能获取到）
const persistToken = localStorage.getItem('persistToken');
if (persistToken && !sessionStorage.getItem('token')) {
  sessionStorage.setItem('token', persistToken);
}

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  // 统一从Vuex获取token（已同步localStorage/sessionStorage）
  let token = store.state.token;
  if (to.matched.some(res => res.meta.requireAuth)) { 
    if (token) { 
      next();
    } else {
      next({
        path: '/', 
        query: { redirect: to.fullPath } 
      });
    }
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js